module.exports = __webpack_public_path__ + "static/1-2a55bd70ecacc2e00d7f82557aa4f0ab.png";